// extracted by mini-css-extract-plugin
module.exports = {"container":"AdBanner_container__BJHNc"};